import { render, staticRenderFns } from "./InventoryTable.container.vue?vue&type=template&id=9bda06fe&scoped=true&"
import script from "./InventoryTable.container.vue?vue&type=script&lang=js&"
export * from "./InventoryTable.container.vue?vue&type=script&lang=js&"
import style0 from "./InventoryTable.container.vue?vue&type=style&index=0&id=9bda06fe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bda06fe",
  null
  
)

export default component.exports